(()=>{
  const PAGE_SELECTOR='[data-product-page]';
  const DELIVERY_ROW_SELECTOR='.product-fulfillment__row--delivery';
  const RESULT_EVENT='elc:express-delivery:result';
  const CONTEXT_EVENT='elc:express-delivery:context';
  const ACTION_EVENT='elc:express-delivery:action';
  const VALID_STATES=new Set(['default','loading','today','tomorrow','standard','unavailable']);
  const DEFAULT_BADGES={loading:'Checking',today:'Today',tomorrow:'Tomorrow',standard:'Standard',unavailable:'Unavailable'};
  const FALLBACK_HEADING='Delivery';
  const FALLBACK_SUMMARY='2–3 working days';
  const FALLBACK_DETAIL='Remote areas may take 5–8 working days.';

  function clean(value){
    if(value===null||value===undefined)return'';
    return String(value).trim();
  }

  function getContext(page,row){
    const select=page.querySelector('[data-variant-select]');
    const option=select?.selectedOptions?.[0]||null;
    const variantId=clean(option?.value||select?.value);
    const detail={
      variantId,
      available:option?.dataset.available==='true',
      sku:clean(option?.dataset.sku),
      sectionId:clean(page.dataset.sectionId),
      productPath:window.location.pathname,
      rootPath:window.Shopify?.routes?.root||'/'
    };
    row.dataset.variantId=variantId;
    row.dataset.variantAvailable=detail.available?'true':'false';
    return detail;
  }

  function resetDelivery(row){
    const content=row.querySelector('.product-fulfillment__content');
    if(!content)return;
    const heading=content.querySelector('[data-express-delivery-heading]');
    const summary=content.querySelector('[data-express-delivery-summary]');
    const subtext=content.querySelector('[data-express-delivery-detail]');
    const badge=content.querySelector('[data-express-delivery-badge]');
    const action=content.querySelector('[data-express-delivery-action]');

    if(heading)heading.textContent=content.dataset.defaultHeading||FALLBACK_HEADING;
    if(summary)summary.textContent=content.dataset.defaultSummary||FALLBACK_SUMMARY;
    if(subtext){
      subtext.textContent=content.dataset.defaultDetail||FALLBACK_DETAIL;
      subtext.hidden=false;
    }
    if(badge){badge.textContent='';badge.hidden=true;}
    if(action){action.textContent='';action.hidden=true;}
    row.dataset.deliveryState='default';
    row.removeAttribute('aria-busy');
  }

  function emitContext(page,row){
    document.dispatchEvent(new CustomEvent(CONTEXT_EVENT,{detail:getContext(page,row)}));
  }

  function syncContext(page,row,force=false){
    const previous=clean(row.dataset.variantId);
    const detail=getContext(page,row);
    const changed=previous!==detail.variantId;
    if(changed)resetDelivery(row);
    if(changed||force)document.dispatchEvent(new CustomEvent(CONTEXT_EVENT,{detail}));
  }

  function decorateDeliveryRow(page,row){
    if(row.dataset.expressDeliveryBridge==='true'){
      syncContext(page,row,true);
      return true;
    }

    const content=row.querySelector('.product-fulfillment__content');
    const heading=content?.querySelector('strong');
    const summary=content?.querySelector('span');
    const subtext=content?.querySelector('small');
    if(!content||!heading||!summary||!subtext)return false;

    const defaultHeading=clean(heading.textContent)||FALLBACK_HEADING;
    const defaultSummary=clean(summary.textContent)||FALLBACK_SUMMARY;
    const defaultDetail=clean(subtext.textContent)||FALLBACK_DETAIL;

    row.dataset.expressDeliveryBridge='true';
    row.dataset.expressDeliverySlot='';
    row.dataset.deliveryState='default';
    content.dataset.defaultHeading=defaultHeading;
    content.dataset.defaultSummary=defaultSummary;
    content.dataset.defaultDetail=defaultDetail;
    content.setAttribute('aria-live','polite');
    content.setAttribute('aria-atomic','true');

    heading.dataset.expressDeliveryHeading='';
    summary.dataset.expressDeliverySummary='';
    subtext.dataset.expressDeliveryDetail='';

    const headingRow=document.createElement('span');
    headingRow.className='product-delivery__heading';
    heading.before(headingRow);
    headingRow.append(heading);

    const badge=document.createElement('span');
    badge.className='product-delivery__badge';
    badge.dataset.expressDeliveryBadge='';
    badge.hidden=true;
    headingRow.append(badge);

    const action=document.createElement('button');
    action.type='button';
    action.className='product-delivery__action';
    action.dataset.expressDeliveryAction='';
    action.hidden=true;
    action.addEventListener('click',()=>{
      document.dispatchEvent(new CustomEvent(ACTION_EVENT,{detail:{...getContext(page,row),state:clean(row.dataset.deliveryState)}}));
    });
    content.append(action);

    emitContext(page,row);
    return true;
  }

  function applyResult(rawDetail){
    const detail=rawDetail&&typeof rawDetail==='object'?rawDetail:{};
    const variantId=clean(detail.variantId);
    if(!variantId)return;

    const requestedState=clean(detail.state).toLowerCase();
    const state=VALID_STATES.has(requestedState)?requestedState:'default';

    document.querySelectorAll(`${PAGE_SELECTOR} [data-express-delivery-slot]`).forEach((row)=>{
      if(clean(row.dataset.variantId)!==variantId)return;
      if(state==='default'){
        resetDelivery(row);
        return;
      }

      const content=row.querySelector('.product-fulfillment__content');
      const heading=content?.querySelector('[data-express-delivery-heading]');
      const summary=content?.querySelector('[data-express-delivery-summary]');
      const subtext=content?.querySelector('[data-express-delivery-detail]');
      const badge=content?.querySelector('[data-express-delivery-badge]');
      const action=content?.querySelector('[data-express-delivery-action]');
      if(!content||!heading||!summary||!subtext||!badge||!action)return;

      row.dataset.deliveryState=state;
      if(state==='loading')row.setAttribute('aria-busy','true');
      else row.removeAttribute('aria-busy');

      if(Object.prototype.hasOwnProperty.call(detail,'title')){
        heading.textContent=clean(detail.title)||content.dataset.defaultHeading||FALLBACK_HEADING;
      }
      if(Object.prototype.hasOwnProperty.call(detail,'message')){
        summary.textContent=clean(detail.message)||content.dataset.defaultSummary||'';
      }
      if(Object.prototype.hasOwnProperty.call(detail,'detail')){
        const value=clean(detail.detail);
        subtext.textContent=value;
        subtext.hidden=!value;
      }

      const badgeLabel=clean(detail.badge)||DEFAULT_BADGES[state]||'';
      badge.textContent=badgeLabel;
      badge.hidden=!badgeLabel;

      const actionLabel=clean(detail.actionLabel);
      action.textContent=actionLabel;
      action.hidden=!actionLabel;
    });
  }

  function initPage(page){
    if(page.dataset.expressDeliveryBridgeInitialized==='true')return;
    page.dataset.expressDeliveryBridgeInitialized='true';

    const prepare=()=>{
      const row=page.querySelector(DELIVERY_ROW_SELECTOR);
      return row?decorateDeliveryRow(page,row):false;
    };

    if(!prepare()&&'MutationObserver'in window){
      const observer=new MutationObserver(()=>{
        if(prepare())observer.disconnect();
      });
      observer.observe(page,{childList:true,subtree:true});
    }

    page.addEventListener('change',(event)=>{
      if(!event.target.closest('[data-option-group]'))return;
      window.requestAnimationFrame(()=>{
        const row=page.querySelector('[data-express-delivery-slot]')||page.querySelector(DELIVERY_ROW_SELECTOR);
        if(row){
          if(row.dataset.expressDeliveryBridge!=='true')decorateDeliveryRow(page,row);
          else syncContext(page,row,true);
        }
      });
    });
  }

  function init(scope=document){
    if(scope.matches?.(PAGE_SELECTOR))initPage(scope);
    scope.querySelectorAll?.(PAGE_SELECTOR).forEach(initPage);
  }

  document.addEventListener(RESULT_EVENT,(event)=>applyResult(event.detail));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());
  else init();
  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();
